import { AxiosService } from '.';

const getActivityLogList = async (_perPage, _page, commonSearch, sortBy) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/activity_logs/list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        sortOption: sortBy,
      },
    };

    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

export { getActivityLogList };
